/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { NgModule } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { ToursModule } from '@tours/tours.module';
import { ConstructionSitesComponent } from './construction-sites/construction-sites.component';
import { TourMonthOverviewComponent } from './tour-month-overview/tour-month-overview.component';

@NgModule({
  declarations: [
    ConstructionSitesComponent,
    TourMonthOverviewComponent
  ],
  imports: [
    SharedModule,
    ToursModule
  ],
  exports: [
    ConstructionSitesComponent
  ]
})
export class ConstructionSitesModule { }
